import place1 from '../../assets/images/place-1.jpg';
import place2 from '../../assets/images/place-2.jpg';
import place3 from '../../assets/images/place-3.jpg';
import place4 from '../../assets/images/place-4.jpg';
import place5 from '../../assets/images/place-5.jpg';
import place6 from '../../assets/images/place-6.jpg';
import place7 from '../../assets/images/place-7.jpg';
import place8 from '../../assets/images/place-8.jpg';
import place9 from '../../assets/images/place-9.jpg';
import place10 from '../../assets/images/place-10.jpg';


const destinations = [
    {
        city: 'Zurich',
        about: 'The cosmopolitan city by the water combines creative urban life with nature in all its glory. Zurich is abuzz with activity day and night with its countless events, diverse museums, own food festival and Switzerland’s most vibrant nightlife.',
        image: place1
    },
    {
        city: 'Bern',
        about: 'Not many cities have managed to retain their historic features quite as successfully as Bern, the capital of Switzerland. The old town of Bern is a UNESCO World Heritage Site.',
        image: place2
    },
    {
        city: 'Matterhorn',
        about: 'The Matterhorn and Switzerland are inseparably linked to each other. The pyramid shaped colossus of a mountain is said to be the most-photographed mountain in the world. The Klein-Matterhorn lies adjacent to the Matterhorn.',
        image: place3
    },
    {
        city: 'Lucerne',
        about: 'Lucerne, the gateway to central Switzerland, sited on Lake Lucerne, is embedded within an impressive mountainous panorama. The town is a destination for many travel groups and individuals on their journey through central Switzerland.',
        image: place4
    },
    {
        city: 'Geneva',
        about: 'Geneva is Switzerland’s most international city, as it is where the European seat of the UNO is based. Besides being a congress city, Geneva is also a centre for culture and history, for trade fairs and exhibitions.',
        image: place5
    },
    {
        city: 'Zermatt',
        about: "Zermatt lies at the foot of the Matterhorn. The town's touristic development is closely linked to what is most probably the world's most famous mountain.",
        image: place6
    },
    {
        city: 'Grindelwald',
        about: 'The Eiger village of Grindelwald in the Bernese Oberland lies embedded in a welcoming and green hollow, surrounded by a commanding mountainscape with the Eiger north face and the Wetterhorn. This mountainscape.',
        image: place7
    },
    {
        city: 'Interlaken',
        about: 'Interlaken lies in the Bernese Oberland on an alluvial plain, between Lake Thun and Lake Brienz. The vacation destination, which is presided over by the three mighty mountains, Eiger, Mönch and Jungfrau, is the starting point for numerous activities.',
        image: place8
    },

    {
        city: 'St. Moritz',
        about: 'St. Moritz is more than just a holiday resort. It was also the birthplace of Alpine winter tourism (in 1864) and has twice hosted the Winter Olympics. Nevertheless, St. Moritz first became famous thanks to its mineral springs.',
        image: place9
    },
    {
        city: 'Montreux',
        about: 'From the lake to the mountains and vineyards, Montreux Riviera offers a postcard landscape. It’s an authentic little piece of paradise that has attracted many artists, writers and travellers in search of beauty, tranquillity and… inspiration.',
        image: place10
    }

];

export default destinations;